/** @format */

import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { UserToken, getUserToken, setUserToken } from "./authSlice";
import { useAppSelector } from "../../app/hooks";
import { Navigate } from "react-router-dom";
import { apiSlice } from "../../app/apiSlice";
import { useTranslation } from "react-i18next";
import { removeCookie } from "../../utils/cookies";

const Logout: FC = () => {
  const dispatch = useDispatch();
  const { t: _ } = useTranslation();

  const token: UserToken | undefined = useAppSelector((state) =>
    getUserToken(state),
  );
  const userToken = localStorage.getItem("userToken");
  const [loggedOut, setLoggedOut] = useState<boolean>(false);

  useEffect(() => {
    if (!token && !userToken) setLoggedOut(true);
    dispatch(setUserToken(undefined));
    dispatch(
      apiSlice.util.invalidateTags([
        "User",
        "UserResourceRef",
        "Resources",
        "ResourceRef",
      ]),
    );
    process.env.REACT_APP_FLAG_COOKIE ?? removeCookie('user_token')
    localStorage.removeItem("BL_CMS_STATE");
    setLoggedOut(true);
  }, [dispatch, token, userToken]);

  return loggedOut ? <p>{_("Loading")}...</p> : <Navigate to="/" />;
};

export default Logout;
